webpackJsonp([84],{

/***/ 1197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = semanticFormField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// import { Form, Input, Dropdown, TextArea } from 'semantic-ui-react';

function semanticFormField(_ref) {
  var input = _ref.input,
      type = _ref.type,
      label = _ref.label,
      placeholder = _ref.placeholder,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning,
      _ref$as = _ref.as,
      As = _ref$as === undefined ? __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Input */] : _ref$as,
      props = _objectWithoutProperties(_ref, ['input', 'type', 'label', 'placeholder', 'meta', 'as']);

  function handleChange(e, _ref2) {
    var value = _ref2.value;

    return input.onChange(value);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Form */].Field,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(As, _extends({}, props, input, { value: input.value, type: type, label: label, placeholder: placeholder, onChange: handleChange })),
    touched && (error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'i',
        null,
        error
      )
    ) || warning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'i',
        null,
        warning
      )
    ))
  );
}

semanticFormField.propTypes = {
  as: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  input: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  meta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),

/***/ 1225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Features_ui_components_semanticForm__ = __webpack_require__(1197);






var emailaddress = function emailaddress(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Label */],
    { basic: true, color: 'red', pointing: true },
    'Invalid email address'
  ) : undefined;
};

var LoginBSRSForm = function LoginBSRSForm(_ref) {
  var handleSubmit = _ref.handleSubmit;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Grid */],
      {
        textAlign: 'center',
        style: { height: '100%' },
        verticalAlign: 'middle'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Grid */].Column,
        { style: { maxWidth: 450 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["l" /* Image */], { size: 'big',
          src: '/assets/images/logo.png'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* Header */],
          { as: 'h2', color: 'pink', textAlign: 'center' },
          ' ',
          'Log-in to your account'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Form */],
          { size: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["v" /* Segment */],
            { stacked: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
              component: __WEBPACK_IMPORTED_MODULE_4_Features_ui_components_semanticForm__["a" /* default */],
              as: __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Form */].Input,
              type: 'text',
              name: 'emailaddress',
              label: 'Email:',
              validate: emailaddress
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["f" /* Divider */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_redux_form__["a" /* Field */], {
              component: __WEBPACK_IMPORTED_MODULE_4_Features_ui_components_semanticForm__["a" /* default */],
              as: __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Form */].Input,
              type: 'password',
              name: 'password',
              label: 'Password:'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["a" /* Button */],
              { color: 'pink', fluid: true, size: 'large', onClick: handleSubmit },
              'Login'
            )
          )
        )
      )
    )
  );
};

LoginBSRSForm.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

function validate(values) {
  var errors = {};
  if (!values.emailaddress) errors.emailaddress = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Label */],
    { basic: true, color: 'red', pointing: true },
    'Required!'
  );
  if (!values.password) errors.password = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Label */],
    { basic: true, color: 'red', pointing: true },
    'Required!'
  );

  return errors;
}

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_form__["d" /* reduxForm */])({
  form: 'loginBSRS',
  validate: validate
})(LoginBSRSForm));

/***/ })

});


// WEBPACK FOOTER //
// 84.cae6c2211b7d4954a05c.js